var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphic_4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 341.167,
    height: 221.959,
    viewBox: "0 0 341.167 221.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(0 40.505)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 16.278,
    cy: 16.278,
    rx: 16.278,
    ry: 16.278,
    transform: "translate(270.083 48.32)",
    fill: "#ffe293"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(275.217 60.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M117.59,75.937a12.692,12.692,0,0,0-6.04-10.067c-6.04-3.775-9.312,2.013-12.584,3.9S94.184,59.83,87.641,54.293s-12-1.007-14.052,6.04-6.837,9.061-12.625,5.537S51.4,74.427,51.652,75.937Z",
    transform: "translate(-51.64 -51.821)",
    fill: "#eeedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M59.375,63.881c-1.581-4.762-5.279-9.35-7.735-12.036,1.883-.15,3.982.566,6.209,2.45,6.544,5.537,8.054,17.365,11.325,15.478s6.543-7.676,12.584-3.9A12.692,12.692,0,0,1,87.8,75.939H59.946A23.516,23.516,0,0,0,59.375,63.881Z",
    transform: "translate(-21.848 -51.824)",
    fill: "#dbd9f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 32.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M566.666,130.5a12.692,12.692,0,0,1,6.04-10.067c6.04-3.775,9.312,2.013,12.584,3.9s4.782-9.941,11.325-15.478,12-1.007,14.052,6.04,6.837,9.06,12.625,5.537,9.563,8.557,9.312,10.067Z",
    transform: "translate(-566.666 -106.381)",
    fill: "#eeedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M574.028,119.876c-1.314-6.835-4.588-10.87-7.362-13.15,4.873-1.561,8.745,2.484,10.4,8.171,2.055,7.047,6.836,9.06,12.625,5.537s9.563,8.557,9.312,10.067H572.933A16.938,16.938,0,0,0,574.028,119.876Z",
    transform: "translate(-533.069 -106.385)",
    fill: "#dbd9f8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35134",
    "data-name": "Group 35134",
    transform: "translate(8.491 155.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M539.846,422.3s-7.136-13.41-10.351-18.6-9.11-5.005-13.214.415-8.692-11.123-10.642-14.928-4.137-8.62-12.866-7.939-12.85,18.514-15.32,24.085-5.684,13.406-13.282,17.713Z",
    transform: "translate(-464.17 -381.178)",
    fill: "#cdcbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M481.458,413.346c-3.09-4.068-10.2-7.865-11.656-20.848a19.416,19.416,0,0,0-5.632-11.316c7.317.042,9.341,4.459,11.157,8,1.95,3.805,6.539,20.348,10.642,14.928s10-5.6,13.214-.414,10.352,18.6,10.352,18.6l-26.945.266C483.059,419.626,483.232,415.683,481.458,413.346Z",
    transform: "translate(-433.86 -381.179)",
    fill: "#7e79c1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35506",
    "data-name": "Group 35506",
    transform: "translate(249.279 166.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M539.846,422.3s-7.136-13.41-10.351-18.6-9.11-5.005-13.214.415-8.692-11.123-10.642-14.928-4.137-8.62-12.866-7.939-12.85,18.514-15.32,24.085-5.684,13.406-13.282,17.713Z",
    transform: "translate(-464.17 -381.178)",
    fill: "#cdcbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M481.458,413.346c-3.09-4.068-10.2-7.865-11.656-20.848a19.416,19.416,0,0,0-5.632-11.316c7.317.042,9.341,4.459,11.157,8,1.95,3.805,6.539,20.348,10.642,14.928s10-5.6,13.214-.414,10.352,18.6,10.352,18.6l-26.945.266C483.059,419.626,483.232,415.683,481.458,413.346Z",
    transform: "translate(-433.86 -381.179)",
    fill: "#7e79c1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35705",
    "data-name": "Group 35705",
    transform: "translate(69.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 40.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M293.086,206.885s9.464-13.265,24.67-17.067,27.879-18.8,27.034-35.379-15.206-22.849-15.206-36.186,6.758-28.121-6.336-46.284S293.08,60.564,280.5,63.1s-26.523-2.957-38.773-17.741-40.551-9.293-48.154,5.069-5.914,23.232-6.758,31.68-6.336,13.094-16.9,23.654-8.026,27.356,2.957,41.345,5.913,42.994,21.542,52.568,36.139,16.773,59.887,14.019S287.683,212.865,293.086,206.885Z",
    transform: "translate(-163.186 -32.832)",
    fill: "#eeedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M168.112,223.685a21.093,21.093,0,0,1-3.191-15.918c1.877-9.238,1.214-12.054-1.083-12.242S156.285,213.172,168.112,223.685Z",
    transform: "translate(14.618 -123.066)",
    fill: "#dbd9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M552.856,281.318s8.026,8.026,10.419,17.319-3.1,7.322-5.21,0S554.4,284.556,552.856,281.318Z",
    transform: "translate(-550.631 -171.782)",
    fill: "#dbd9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M481.031,29.174a30.418,30.418,0,0,0-16.145,5.069s-2.065,1.784-3.661,0S469.2,24.857,481.031,29.174Z",
    transform: "translate(-428.119 -27.866)",
    fill: "#dbd9f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35125",
    "data-name": "Group 35125",
    transform: "translate(23.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M298.109,168.9s6.311-5.032,13.7-2.508,12.616,7.75,13.7,14.057,1.623,7.75,5.948,10.453,7.569,10.093,0,17.482-28.657,9.372-37.668,8.29-7.209-8.29-4.866-12.075-2.116-7.029-1.6-11.534,4.483-5.407,4.662-11.174S292.665,171.55,298.109,168.9Z",
    transform: "translate(-243.206 -165.686)",
    fill: "#16293b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M319.188,180.975s5.948,9.372,17.122,11.715a23.187,23.187,0,0,1,0,6.038s1.352-2.073,2.343-3.965,2.794-1.712,3.424,0,.541,5.857-2.883,7.029a12.165,12.165,0,0,0-1.172,3.965,49.027,49.027,0,0,0,.721,6.578s-1.949,8.741-7.958,13.427a98.465,98.465,0,0,1,0-11.535l-.422-4.416s-7.66,2.7-12.075-1.622-3.695-12.166-3.695-16.04-.044-5.768-.044-5.768S316.395,182.236,319.188,180.975Z",
    transform: "translate(-264.823 -172.517)",
    fill: "#ffccb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M327.965,231.5s2.253-.991,4.6-1.983c0,0-2.543,3.345-4.38,4.241Z",
    transform: "translate(-262.425 -194.205)",
    fill: "#16293b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(42.29 103.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10761",
    "data-name": "Path 10761",
    d: "M0,0H52.768V50.825H0Z",
    fill: "#cbc8f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M335.682,352.341v50.825H282.913l52.606-50.825Z",
    transform: "translate(-282.913 -352.341)",
    fill: "#e1dffa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 7.904,
    height: 50.825,
    transform: "translate(20.955)",
    fill: "#fdfcfd",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10762",
    "data-name": "Path 10762",
    d: "M0,0V50.825",
    transform: "translate(24.908)",
    fill: "none",
    stroke: "rgba(100,87,232,0.31)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M289.386,268.286c.856-1.442-.736-11.174,0-15.5s1.216-6.609,5.422-9.252a46.375,46.375,0,0,1,7.932-4,98.457,98.457,0,0,0,0,11.535c6.009-4.686,7.958-13.427,7.958-13.427s11.745-.841,15.35,8.651,6.729,19.585,5.527,21.628-9.252,4.926-9.252,4.926l1.922,4.926s-11.783-.721-19.169-.481-8.948.481-8.948.481H282.913V271.77S288.53,269.727,289.386,268.286Z",
    transform: "translate(-236.778 -197.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M302.956,323.535c1.8-5.768,3.6-6.849,10.093-7.569,0,0,2.042-3.184,13.157-4.686l11.114-1.5s1.562-.24,8.948-.481,19.168.481,19.168.481,5.107,14.3-4.266,21.688-33.027,4.686-33.027,4.686-1.711,23.79-6.059,31c0,0-2.186,1.8-6.872,0l-3.245-23.25s-4.505,10.994-10.273,17.482c0,0-5.406.721-7.57-1.8C294.125,359.58,301.154,329.3,302.956,323.535Z",
    transform: "translate(-277.968 -229.829)",
    fill: "#261e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M332.028,311.887H312.2l-1.667-1.682h21.493Z",
    transform: "translate(-252.251 -230.256)",
    fill: "#17273e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M341.471,299.954l1.447,5-15.573.524s3-3,5.046-4.806S341.471,299.954,341.471,299.954Z",
    transform: "translate(-272.439 -225.533)",
    fill: "#c37557"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 15.066,
    y2: 4.402,
    transform: "translate(70.479 75.022)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M294.125,293.124s7.142-4.205,10.746-5.887,6.862-3,9.079-2.884",
    transform: "translate(-225.094 -218.702)",
    fill: "none",
    stroke: "#eaeaea",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M308.317,261.934,314,274.7a67.747,67.747,0,0,0-15.027,7.182s7.457-5.857,9.259-9.974S308.317,261.934,308.317,261.934Z",
    transform: "translate(-227.818 -208.689)",
    fill: "#ebeced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M347.965,260.685s-2.883,4.566-2.283,8.531,1.922,4.085,2.883,6.248,0,7.81,0,7.81",
    transform: "translate(-288.614 -208.131)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M400.605,328.984c1.779-5.691,3.566-6.819,9.848-7.54a23.442,23.442,0,0,1-.228,3.763c-1.183,4.854-2.41,12.338-.442,25.333l-.167-1.19s-4.505,10.994-10.273,17.482c0,0-5.406.721-7.569-1.8C391.774,365.03,398.8,334.751,400.605,328.984Z",
    transform: "translate(-375.617 -235.278)",
    fill: "#140c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M391.076,413.915s1.3,8.471,1.3,11.114-5.837,5.046-11.389,6.128-7.114,1.081-8.2-1.2,4.546-3.444,7.139-7.069a37.69,37.69,0,0,0,4.276-8.972S387.855,415.658,391.076,413.915Z",
    transform: "translate(-346.96 -276.594)",
    fill: "#dbd9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M435.583,402.034s-2.824,7.99-3.544,10.033-6.609,3.526-13.1,4.706-7.69-1.943-6.849-4.225,8.651-5.407,10.934-6.849,4.986-5.467,4.986-5.467S429.035,402.455,435.583,402.034Z",
    transform: "translate(-411.857 -270.48)",
    fill: "#dbd9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M396.3,296.652,375.93,276.106H346.373l21.267,20.546Z",
    transform: "translate(-336.344 -215.021)",
    fill: "#17273e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlProducts);
export default __webpack_public_path__ + "static/media/il-products.d8e8817430a86aa534e03d57af8e1371.svg";
export { ForwardRef as ReactComponent };